<template>
    <div class="reimbursement-invoice-table">
        <el-table
            :data="datas"
            style="width: 100%"
            class="row-click ah-el-data-table"
            :row-class-name="getRowClass"
            @row-click="handleDataRowClick"
            @sort-change="onSortChange"
            :default-sort="sortSetting"
            empty-text="沒有資料"
            v-loading="loading"
        >
            <el-table-column prop="tioo" label="單號" width="120" sortable></el-table-column>
            <el-table-column prop="description" label="摘要" min-width="200" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="vdR_NAM" label="買受人" min-width="200" :show-overflow-tooltip="true" sortable>
                <template slot-scope="scope">
                    <div>{{ scope.row.vdR_NAM }}</div>
                    <div>{{ scope.row.bsn }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="foo" label="發票號碼" width="120" :show-overflow-tooltip="true" sortable>
                <template slot-scope="scope">
                    <div>
                        <div style="font-size: 10pt">
                            <ahReceiptNumber :v="scope.row.foo" />
                        </div>
                        <div>
                            <div class="amt-refund" v-if="scope.row.foO_CNL">作廢</div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="foO_DAT" label="發票開立日期" width="125" :show-overflow-tooltip="true" sortable>
                <template slot-scope="scope">
                    <span>
                        {{ scope.row.foO_DAT | dateFormater("YYYY-MM-dd") }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="amt" label="含稅總計" align="right" width="110" sortable>
                <template slot-scope="scope">
                    <Money :v="scope.row.amt" />
                    <ahTip v-if="scope.row.cny != 'TWD'">
                        <div>
                            約當台幣：
                            <Money :v="scope.row.amt * scope.row.rat" round />
                        </div>
                        <div style="opacity: 0.8; font-size: 10pt; margin-top: 5px">匯率：{{ Math.round(scope.row.rat * 100) / 100 }}</div>
                    </ahTip>
                    <div v-else-if="scope.row.foO_DIS_AMT" class="amt-refund">
                        <span v-if="scope.row.foO_DIS === 2">退回 </span>
                        <span v-if="scope.row.foO_DIS === 1">折讓 </span>
                        <Money :v="scope.row.foO_DIS_AMT" />
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="cny" label="幣別" width="75" sortable></el-table-column>
            <el-table-column prop="crT_USR" label="申請人" width="100" sortable></el-table-column>
        </el-table>
        <ReimbursementInvoiceDetailDialog :visible="detailDialogVisible" :tioo="detailDialogTioo" @close="handleDetailDialogClose" />
    </div>
</template>

<script>
import ahReceiptNumber from '@/components/ui/ahReceiptNumber.vue';

export default {
    name: 'ReimbursementInvoiceTable',
    components: {
        ahReceiptNumber,
        ReimbursementInvoiceDetailDialog: () => import('@/components/dashboard/Finance/ReimbursementInvoice/ReimbursementInvoiceDetailDialog.vue'),
    },
    props: {
        datas: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        isSortByDate: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            detailDialogVisible: false,
            detailDialogTioo: null,
            lastDetailDialogSno: null,

            showPjCustomNumber: false,
        };
    },
    computed: {
        sortSetting() {
            if (this.isSortByDate) {
                return { prop: 'crT_DAT', order: 'descending' };
            }
            return { prop: null, order: null };
        },
    },
    methods: {
        // 按下表格一行
        handleDataRowClick(data) {
            this.detailDialogVisible = true;
            this.detailDialogTioo = data.tioo;
            this.lastDetailDialogSno = null;
        },

        handleDetailDialogClose(refresh) {
            this.lastDetailDialogSno = this.detailDialogTioo;
            this.detailDialogVisible = false;
            this.detailDialogTioo = null;
            this.$emit('detailClose', refresh);
        },
        getRowClass({ row }) {
            if (row.sno === this.detailDialogTioo) {
                return 'curr-detail-dialog-target';
            }
            if (row.sno === this.lastDetailDialogSno) {
                return 'last-detail-dialog-target';
            }
            return '';
        },
        onSortChange(event) {
            this.$emit('sort-change', event);
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.reimbursement-invoice-table {
    .amt-refund {
        color: red;

        .label {
            display: inline-block;
            border: 1px solid red;
            border-radius: 5px;
            padding: 0px 10px;
            margin-right: 10px;
        }
    }
}
</style>
